module.exports = __webpack_public_path__ + "static/media/menu_btn.54daeeda.svg";